import { InputSelect } from "@UI/InputNew";
import { useMemo } from 'react';
import s from './index.module.css';

const Time = ({changeRegularity, index, hour, minutes, firstField}) => {
    const optionsHour = useMemo(()=>{
        const option = [];
        for(let i=0; i < 24; i++){
            option.push(
                {
                    label: `${i}`,
                    value: i
                }
            )
        }
        return option;
    }, [])

    const optionsMinutes = useMemo(()=>{
        const option = [];
        for(let i=0; i < 60; i++){
            option.push(
                {
                    label: `${i}`,
                    value: i
                }
            )
        }
        return option;
    }, [])

    return (
        <>
            <InputSelect
                options={optionsHour}
                newDesign
                value={hour}
                onChange={
                    (e) => {
                        changeRegularity(index, e.target.value, firstField, 'hour')
                    }
                }
                className={s.select} 
                classNameBox={s.selectBox}
                hideIcon={true}
                popupClassName={s.popupClassName}
            />
            <InputSelect
                options={optionsMinutes}
                newDesign
                value={minutes}
                onChange={
                    (e) => {
                        changeRegularity(index, e.target.value, firstField, 'minutes')
                    }
                }
                className={s.select} 
                classNameBox={s.selectBox}
                hideIcon={true}
                popupClassName={s.popupClassName}
            />
        </>
    )
}

export default Time;